// extracted by mini-css-extract-plugin
export default {"floatingLayer":"css_floatingLayer__wAW8-"};